import * as React from "react";
import {
  VideoView,
  useVideoPlayer,
  StatusChangeEventPayload,
} from "expo-video";
import { isWeb } from "~/utils/platform";

interface Props {
  width: number;
  height: number;
  uri: string;
  onSize: (size: number) => void;
}

interface NaturalSize {
  width: number;
  height: number;
}

export const InAppVideo = React.memo<Props>(
  ({ width, height, uri, onSize }) => {
    const videoRef = React.useRef(null);
    const player = useVideoPlayer(uri, (playerInstance) => {
      playerInstance.loop = false;
    });

    React.useEffect(() => {
      const subscription = player.addListener(
        "statusChange",
        (payload: StatusChangeEventPayload & { naturalSize?: NaturalSize }) => {
          if (payload.status === "readyToPlay" && payload.naturalSize) {
            const { naturalSize } = payload;
            if (naturalSize.width && naturalSize.height) {
              onSize((width * naturalSize.height) / naturalSize.width);
            }
          }
        }
      );

      return () => {
        subscription.remove();
      };
    }, [player, width, onSize]);

    if (isWeb) {
      return (
        <video
          style={{ width, height }}
          ref={videoRef}
          controls
          onLoadedMetadata={() => {
            const videoElement = videoRef.current;

            if (videoElement) {
              const { videoWidth, videoHeight } = videoElement;
              onSize((width * videoHeight) / videoWidth);
              console.log(`Video dimensions: ${videoWidth}x${videoHeight}`);
            }
          }}
        >
          <source src={uri} type="video/mp4" />
        </video>
      );
    }

    return (
      <VideoView
        player={player}
        style={{ width, height }}
        contentFit="contain"
        nativeControls
      />
    );
  }
);
